import { render, staticRenderFns } from "./ReportCompanyDataContainer.vue?vue&type=template&id=6be996a0&scoped=true"
import script from "./ReportCompanyDataContainer.vue?vue&type=script&lang=js"
export * from "./ReportCompanyDataContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be996a0",
  null
  
)

export default component.exports